import { Link } from 'react-router-dom';
import { getHotVideos } from '@/mocks/videos';

export default function FeaturedSection() {
  const hotVideos = getHotVideos();

  return (
    <section className="w-full px-4 md:px-6 lg:px-8 py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-1">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-600">大家都在看的精彩内容</p>
          </div>
          <Link
            to="/category/dianshiju"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 cursor-pointer whitespace-nowrap"
          >
            查看更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {hotVideos.map((video) => (
            <Link
              key={video.id}
              to={`/article/${video.id}`}
              className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer transition-all hover:scale-[1.02]"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={video.thumbnail}
                  alt={video.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-medium bg-primary-500 text-white rounded-full whitespace-nowrap">
                    {video.rating}
                  </span>
                </div>
                <div className="absolute top-3 right-3">
                  <span className="px-2.5 py-1 text-xs font-medium bg-black/50 text-white rounded-full backdrop-blur-sm whitespace-nowrap">
                    {video.source}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading font-semibold text-foreground-950 text-base mb-2 group-hover:text-primary-600 transition-colors">
                  {video.title}
                </h3>
                <p className="text-xs text-foreground-600 line-clamp-2 leading-relaxed mb-3">
                  {video.description}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-500">{video.updateInfo}</span>
                  <span className="text-xs px-2 py-1 rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap">
                    {video.category}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}